import { css } from "styled-components"
import Lottie from "lottie-react"

import { useGetDailyCheckInDetails, useGetSeasonThreeUserByWallet } from "../../queries";
import { usePushWalletContext } from "@pushchain/ui-kit";
import { walletToFullCAIP10 } from "../../helpers/web3helper";

import { Box, Text } from "../../blocks"
import StreakBg from "../../../static/assets/website/rewards/streak-bg.webp"
import StreakFireAnimation from "../../../static/assets/website/rewards/streak-fire.json"
import { fadeInCss } from "./utils/FadeIn"

export const StreakDays = () => {
  const { universalAccount } = usePushWalletContext('wallet1');
  const caip10WalletAddress = walletToFullCAIP10(universalAccount?.address as string, universalAccount?.chain);
  const { data: userDetails } = useGetSeasonThreeUserByWallet({ walletAddress: caip10WalletAddress });
  const { data: getDailyCheckInDetails } = useGetDailyCheckInDetails(userDetails?.userId);

  return(
    <Box
      borderRadius="radius-md"
      padding="spacing-md"
      // height={{ initial: '100%', tb: 'auto' }}
      minHeight={{ tb: '200px' }}
      position="relative"
      overflow="hidden"
      width={{ initial: '188px', tb: '100%' }}
      css={css`
            background: ${getDailyCheckInDetails?.streak > 0
              ? 'radial-gradient(163.4% 88% at 50% 12%, rgba(0, 0, 0, 0.20) 47.64%, #5D180E 100%)'
              : 'rgba(0, 0, 0, 0.10)'};
            background-blend-mode: plus-lighter;
            box-shadow: 2.788px -8px 12px 0 rgba(255, 255, 255, 0.15) inset, 1.858px 1.732px 6px 0 rgba(255, 255, 255, 0.15) inset;
            backdrop-filter: blur(10px);
            box-sizing: border-box;
            z-index: 3;
            ${fadeInCss(100)}


            &::before {
              content: '';
              position: absolute;
              inset: 0;
              border-radius: inherit;
              padding: 1px;
              background: rgba(171, 70, 248, 0.40);
              -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
              mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
              -webkit-mask-composite: xor;
              mask-composite: exclude;
              z-index: 2;
            }
        `}>
        {getDailyCheckInDetails?.streak > 0 ? (
          <Lottie
            animationData={StreakFireAnimation}
            loop
            rendererSettings={{ preserveAspectRatio: 'xMidYMax slice' }}
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              pointerEvents: 'none',
              zIndex: 0,
            }}
          />
        ) : (
          <Box
            css={css`
              position: absolute;
              bottom: 1px;
              right: 1px;
              width: 65%;
              height: 65%;
              background: url(${StreakBg}) no-repeat bottom right;
              background-size: contain;
              pointer-events: none;
              z-index: 0;
              border-radius: inherit;
            `}
          />
        )}

        <Box
          css={css`
            position: relative;
            z-index: 1;
          `}
        >
          <Text variant="h1-bold">
            {getDailyCheckInDetails?.streak}
          </Text>

          <Text css={css`
            color: rgba(255, 255, 255, 0.75);
            font-size: 14.198px;
            font-style: normal;
            font-weight: 700;
            line-height: 17.353px;
            letter-spacing: 0.394px;
            `}>
              Streak <br /> Days
          </Text>
        </Box>
    </Box>
  )
}
